import React, { useEffect } from 'react';
import { useEventTrackerContext } from '../../../contexts/EventTracker';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Container from '@material-ui/core/Container';

const useStyles = makeStyles((theme: any) => ({
  root: {
    maxWidth: 700,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  bold: { fontWeight: 'bold' },
  loader: {
    color: theme.palette.lightBlack,
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(6),
  },
  subheader: { color: theme.palette.primary.main },
}));

export default function FinishedPreQualify() {
  const classes = useStyles();
  const { trackEvent } = useEventTrackerContext();

  useEffect(() => {
    trackEvent({ event: 'details_completed' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container className={classes.root}>
      <Typography variant="h4" component="h5" className={classes.bold}>
        <span>Thanks!</span>
        <br />
        <span>We're crunching some numbers...</span>
      </Typography>{' '}
      <CircularProgress className={classes.loader} size={80} />
      <Typography
        variant="h5"
        component="h5"
        className={classes.bold + ' ' + classes.subheader}
      >
        Get ready to build a plan that will:
      </Typography>{' '}
      <Typography variant="h5" component="h5">
        Grow your revenue <br />
        Increase your margin <br />
        Improve your operations
      </Typography>{' '}
    </Container>
  );
}
